export const AUTOMATION_TEMPLATE_KEYS = [
    'reply_tag_webhook_note',
    'lead_created_tag_note',
    'reply_skip_enroll_guard',
    'reply_agent_draft',
];
export const AUTOMATION_TEMPLATES = {
    reply_tag_webhook_note: {
        key: 'reply_tag_webhook_note',
        name: 'Reply → tag + webhook + notitie',
        description: 'Bij reply.received (optioneel campagne-filter): tag, automation.executed, lead notitie.',
        trigger_type: 'event',
        trigger_config: { event_type: 'reply.received' },
        filter: { all: [{ path: 'payload.lead_id', op: 'exists' }] },
        params: [
            { key: 'campaign_id', label: 'Campagne UUID (filter)', type: 'uuid' },
            { key: 'tag', label: 'Tag', type: 'string', required: true },
            { key: 'note_body', label: 'Notitie', type: 'text' },
        ],
        steps: [
            { step_order: 0, step_type: 'lead_add_tag', config: { tag: '{{tag}}' } },
            { step_order: 1, step_type: 'emit_webhook', config: { include_trigger_payload: true } },
            {
                step_order: 2,
                step_type: 'lead_append_note',
                config: {
                    body: '{{note_body}}',
                    also_append_leads_notes: false,
                },
            },
        ],
    },
    lead_created_tag_note: {
        key: 'lead_created_tag_note',
        name: 'Lead aangemaakt → tag + notitie',
        description: 'Na lead.created: tag en interne notitie (geen mail).',
        trigger_type: 'event',
        trigger_config: { event_type: 'lead.created' },
        filter: { all: [{ path: 'payload.lead_id', op: 'exists' }] },
        params: [
            { key: 'tag', label: 'Tag', type: 'string', required: true },
            { key: 'note_body', label: 'Notitie', type: 'text' },
        ],
        steps: [
            { step_order: 0, step_type: 'lead_add_tag', config: { tag: '{{tag}}' } },
            {
                step_order: 1,
                step_type: 'lead_append_note',
                config: { body: '{{note_body}}', also_append_leads_notes: false },
            },
        ],
    },
    reply_skip_enroll_guard: {
        key: 'reply_skip_enroll_guard',
        name: 'Reply → tag enroll-block (guard)',
        description: 'Zet tag enroll-block op reply; gebruik in enroll policy skip_if_tags (Wave 1 guard W1.4).',
        trigger_type: 'event',
        trigger_config: { event_type: 'reply.received' },
        filter: { all: [{ path: 'payload.lead_id', op: 'exists' }] },
        params: [{ key: 'campaign_id', label: 'Campagne UUID (filter)', type: 'uuid' }],
        steps: [{ step_order: 0, step_type: 'lead_add_tag', config: { tag: 'enroll-block' } }],
    },
    reply_agent_draft: {
        key: 'reply_agent_draft',
        name: 'Reply → agent + concept antwoord',
        description: 'Bij reply.received: LLM-agent analyseert inbound, daarna outbound draft (approval).',
        trigger_type: 'event',
        trigger_config: { event_type: 'reply.received' },
        filter: { all: [{ path: 'payload.lead_id', op: 'exists' }] },
        params: [
            { key: 'agent_id', label: 'Agent UUID', type: 'uuid', required: true },
            { key: 'campaign_id', label: 'Campagne UUID (filter)', type: 'uuid' },
        ],
        steps: [
            { step_order: 0, step_type: 'run_agent', config: { agent_id: '{{agent_id}}' } },
            {
                step_order: 1,
                step_type: 'draft_reply',
                config: { require_approval: true },
            },
        ],
    },
};
export function resolveAutomationTemplate(key, params) {
    const tpl = AUTOMATION_TEMPLATES[key];
    const replace = (v) => {
        if (typeof v === 'string') {
            return v.replace(/\{\{(\w+)\}\}/g, (_, k) => params[k]?.trim() ?? '');
        }
        if (Array.isArray(v))
            return v.map(replace);
        if (v && typeof v === 'object') {
            return Object.fromEntries(Object.entries(v).map(([a, b]) => [a, replace(b)]));
        }
        return v;
    };
    let filter = structuredClone(tpl.filter ?? { all: [] });
    if (params.campaign_id?.trim()) {
        filter = {
            all: [
                ...(filter.all ?? []),
                { path: 'payload.campaign_id', op: 'eq', value: params.campaign_id.trim() },
            ],
        };
    }
    const steps = tpl.steps.map((s) => ({
        ...s,
        config: replace(s.config),
    }));
    const nameSuffix = params.campaign_id ? ` (${params.campaign_id.slice(0, 8)}…)` : '';
    return {
        name: `${tpl.name}${nameSuffix}`,
        trigger_type: tpl.trigger_type,
        trigger_config: tpl.trigger_config,
        filter,
        steps,
    };
}
//# sourceMappingURL=templates.js.map